import { ApiFieldReferenceEntity } from "@/types/custom-field.types.ts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useEntityReferenceDirectories() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        id: ApiFieldReferenceEntity.legal_entity,
        title: t("core:legal_entities"),
      },
      {
        id: ApiFieldReferenceEntity.department,
        title: t("core:departments"),
      },
      {
        id: ApiFieldReferenceEntity.division,
        title: t("core:divisions"),
      },
      {
        id: ApiFieldReferenceEntity.location,
        title: t("common:locations"),
      },
    ],
    [t]
  );
}
